import { useState } from 'react';
import { useEmail } from '@/state/email';
import { formatRelativeTime } from '@/lib/time';
import { cn } from '@/lib/cn';

export function Inbox() {
  const emails = useEmail((s) => s.emails);
  const open = useEmail((s) => s.open);
  const unread = emails.filter((e) => !e.read).length;
  const [filter, setFilter] = useState('');
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const filterLc = filter.trim().toLowerCase();
  const visible = emails.filter((e) => {
    if (showUnreadOnly && e.read) return false;
    if (!filterLc) return true;
    return (
      e.subject.toLowerCase().includes(filterLc) ||
      e.fromAddress.toLowerCase().includes(filterLc) ||
      e.fromNpc.toLowerCase().includes(filterLc) ||
      e.body.toLowerCase().includes(filterLc)
    );
  });

  return (
    <div className="flex h-full flex-col">
      <header className="flex items-center justify-between border-b border-[var(--border-subtle)] bg-[var(--bg-surface)] px-4 py-3">
        <span className="text-mono-md font-bold text-[var(--text-primary)]">Inbox</span>
        <span className="text-mono-xs text-[var(--text-muted)]">{unread} unread</span>
      </header>
      <div className="flex items-center gap-2 border-b border-[var(--border-subtle)] bg-[var(--bg-deep)] px-2 py-1">
        <input
          type="text"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="filter…"
          className="flex-1 bg-transparent text-mono-xs text-[var(--text-primary)] placeholder:text-[var(--text-muted)] outline-none"
        />
        <button
          onClick={() => setShowUnreadOnly((v) => !v)}
          className={cn(
            'rounded border px-2 py-0.5 text-[10px] uppercase tracking-wider',
            showUnreadOnly
              ? 'border-[var(--accent-primary)] bg-[var(--accent-primary)] text-black'
              : 'border-[var(--border-subtle)] text-[var(--text-muted)]',
          )}
        >
          unread only
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        {visible.map((e) => (
          <button
            key={e.id}
            onClick={() => open(e.id)}
            className={cn(
              'flex w-full flex-col gap-0.5 border-b border-[var(--border-subtle)] px-4 py-3 text-left hover:bg-[var(--bg-elevated)]',
              !e.read && 'bg-[var(--bg-surface)]',
            )}
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className={cn(
                'truncate text-mono-sm',
                !e.read ? 'font-bold text-[var(--text-primary)]' : 'text-[var(--text-secondary)]',
              )}>
                {e.fromAddress}
              </span>
              <span className="shrink-0 text-mono-xs text-[var(--text-muted)]">
                {formatRelativeTime(e.timestamp)}
              </span>
            </div>
            <span className={cn(
              'truncate text-mono-sm',
              !e.read ? 'text-[var(--text-primary)]' : 'text-[var(--text-secondary)]',
            )}>
              {e.starred && '★ '}{e.subject}
            </span>
            <span className="truncate text-mono-xs text-[var(--text-muted)]">
              {e.body.split('\n')[0]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
